/**
 * FRONT-2594 — a trailing-edge debounce for the draft's localStorage write, so
 * a keystroke does not serialise the whole document into storage. `flush` writes
 * a pending value NOW (unmount, pagehide, switching item); `cancel` drops it
 * (a save or discard just cleared the stored draft, so a late write must not
 * resurrect it).
 */
export interface DebouncedWriter<T> {
  schedule: (value: T) => void;
  flush: () => void;
  cancel: () => void;
}

export function createDebouncedWriter<T>(write: (value: T) => void, ms: number): DebouncedWriter<T> {
  let timer: ReturnType<typeof setTimeout> | null = null;
  let pending: { value: T } | null = null;
  return {
    schedule(value) {
      pending = { value };
      if (timer !== null) clearTimeout(timer);
      timer = setTimeout(() => this.flush(), ms);
    },
    flush() {
      if (timer !== null) clearTimeout(timer);
      timer = null;
      const p = pending;
      pending = null;
      if (p) write(p.value);
    },
    cancel() {
      if (timer !== null) clearTimeout(timer);
      timer = null;
      pending = null;
    },
  };
}
